import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnboardingPanelComponent } from './onboarding-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { OnboardingPanelCardModule } from './components/onboarding-panel-card/onboarding-panel-card.module';
import { SimplebarAngularModule } from 'simplebar-angular';

@NgModule({
  declarations: [OnboardingPanelComponent],
  exports: [OnboardingPanelComponent],
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule,
    SimplebarAngularModule,
    OnboardingPanelCardModule,
  ],
})
export class OnboardingPanelModule { }
